module.exports = __webpack_public_path__ + "img/icon_huoshan.97928850.png";